import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const ContainerModel = styled.div`
  background: #fff;
  border-radius: 20px;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    max-width: 709px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1440px) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

export const ContentModel = styled.div`
  max-width: 100%;
  padding: 16px;

  @media (min-width: 1024px) {
    padding: 24px;
  }
`;

export const HeaderContainerModel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitlePolicy = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Bold";

  @media (min-width: 1440px) {
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const DatePolicy = styled.h2`
  font-size: 16px;
  font-family: "Exo2 Medium";
  line-height: 1.2;
  margin-top: 20px;

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
  }
`;

export const NameItemTitle = styled.h3`
  font-size: 16px;
  font-family: "Exo2 Regular";
  line-height: 1.2;
  margin-top: 20px;

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
  }
`;

export const SimpleText = styled.p`
  font-size: 16px;
  line-height: 1.2;
  text-align: justify;
  margin-top: 10px;

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
    margin-top: 20px;
  }
`;

export const SimpleTextWithoutSpace = styled.p`
  font-size: 16px;
  line-height: 1.2;
  text-align: justify;

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
  }
`;

export const BoldText = styled.span`
  font-size: 16px;
  font-family: "Exo2 Medium";
  line-height: 1.2;

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
  }
`;

export const ListItem = styled.li`
  font-size: 16px;
  line-height: 1.2;
  text-align: justify;
  margin-top: 10px;

  &:first-child {
    margin-top: 0px;
  }

  @media (min-width: 1440px) {
    font-size: 20px;
    line-height: 1.18;
    margin-top: 20px;
  }
`;
